import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container">
            <div className="privacy-policy-content">
                <h1>개인정보처리방침</h1>
                
                <section className="policy-section">
                    <p className="effective-date">
                        시행일자: 2026년 2월 12일
                    </p>
                    <p className="intro">
                        주식회사 에이원링크(이하 "회사")는 개인정보 보호법 제30조에 따라 정보주체의 개인정보를 보호하고 
                        이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>제1조 (개인정보의 처리 목적)</h2>
                    <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 
                    이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                    
                    <div className="subsection">
                        <h3>1. 회원 가입 및 관리</h3>
                        <ul>
                            <li>회원 가입의사 확인</li>
                            <li>회원제 서비스 제공에 따른 본인 식별·인증</li>
                            <li>회원자격 유지·관리</li>
                            <li>서비스 부정이용 방지</li>
                            <li>각종 고지·통지</li>
                            <li>고충처리</li>
                        </ul>
                    </div>

                    <div className="subsection">
                        <h3>2. 묘지 관리 서비스 제공</h3>
                        <ul>
                            <li>고인 및 연고자 정보 관리</li>
                            <li>묘지 위치 안내 및 길찾기 서비스</li>
                            <li>방문 기록 관리</li>
                            <li>계약 정보 조회</li>
                            <li>서비스 제공에 관한 계약 이행</li>
                        </ul>
                    </div>

                    <div className="subsection">
                        <h3>3. 마케팅 및 광고에 활용</h3>
                        <ul>
                            <li>신규 서비스 개발 및 맞춤 서비스 제공</li>
                            <li>이벤트 및 광고성 정보 제공 및 참여기회 제공</li>
                            <li>서비스의 유효성 확인</li>
                        </ul>
                    </div>
                </section>

                <section className="policy-section">
                    <h2>제2조 (개인정보의 처리 및 보유 기간)</h2>
                    <p>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 
                    개인정보를 처리·보유합니다.</p>
                    
                    <div className="subsection">
                        <h3>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</h3>
                        <ul>
                            <li><strong>회원 가입 및 관리:</strong> 회원 탈퇴 시까지 (단, 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지)</li>
                            <li><strong>서비스 제공:</strong> 서비스 이용계약 종료 시까지 (단, 채권·채무관계 잔존 시에는 해당 채권·채무관계 정산 시까지)</li>
                            <li><strong>본인인증 정보:</strong> 본인인증 완료 후 즉시 파기 (단, DI는 중복가입 방지를 위해 회원 탈퇴 시까지 보관)</li>
                            <li><strong>방문 기록:</strong> 수집일로부터 1년 또는 사용자 삭제 시까지</li>
                        </ul>
                    </div>

                    <div className="subsection">
                        <h3>관련 법령에 따른 정보보유 사유</h3>
                        <ul>
                            <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                            <li>대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                            <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                            <li>표시·광고에 관한 기록: 6개월 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                            <li>세법이 규정하는 모든 거래에 관한 장부 및 증빙서류: 5년 (국세기본법)</li>
                            <li>전자금융 거래에 관한 기록: 5년 (전자금융거래법)</li>
                            <li>서비스 방문 기록: 3개월 (통신비밀보호법)</li>
                        </ul>
                    </div>
                </section>

                <section className="policy-section">
                    <h2>제3조 (처리하는 개인정보의 항목)</h2>
                    <p>회사는 다음의 개인정보 항목을 처리하고 있습니다.</p>
                    
                    <div className="subsection">
                        <h3>1. 회원 가입 및 관리</h3>
                        <ul>
                            <li><strong>필수항목:</strong> 성명, 생년월일, 성별, 휴대폰번호, 본인인증정보(CI, DI)</li>
                            <li><strong>선택항목:</strong> 마케팅 수신 동의</li>
                        </ul>
                    </div>

                    <div className="subsection">
                        <h3>2. 서비스 이용 과정에서 자동으로 생성되어 수집되는 정보</h3>
                        <ul>
                            <li>서비스 이용기록</li>
                            <li>접속 로그</li>
                            <li>위치정보 (GPS 좌표)</li>
                            <li>방문 기록</li>
                            <li>기기정보 (OS 버전, 앱 버전)</li>
                        </ul>
                    </div>

                    <div className="subsection">
                        <h3>3. 고인 및 연고자 정보 (서비스 제공을 위해 필요한 경우)</h3>
                        <ul>
                            <li>고인 정보: 성명, 생년월일, 사망일, 주민등록번호, 주소</li>
                            <li>연고자 정보: 성명, 연락처, 주소, 관계</li>
                        </ul>
                    </div>
                </section>

                <section className="policy-section">
                    <h2>제4조 (개인정보의 제3자 제공)</h2>
                    <p>회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 
                    정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
                    
                    <div className="subsection">
                        <h3>회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</h3>
                        
                        <div className="third-party-item">
                            <h4>1. 본인인증 서비스</h4>
                            <ul>
                                <li><strong>제공받는 자:</strong> NICE평가정보(주)</li>
                                <li><strong>제공 목적:</strong> 본인 확인 및 실명 인증</li>
                                <li><strong>제공 항목:</strong> 성명, 생년월일, 성별, 휴대폰번호, 통신사</li>
                                <li><strong>보유 및 이용기간:</strong> 본인인증 완료 후 즉시 파기</li>
                            </ul>
                        </div>

                        <div className="third-party-item">
                            <h4>2. 알림톡 발송 서비스</h4>
                            <ul>
                                <li><strong>제공받는 자:</strong> (주)비즈뿌리오</li>
                                <li><strong>제공 목적:</strong> 인증번호 및 알림 메시지 발송</li>
                                <li><strong>제공 항목:</strong> 휴대폰번호, 인증번호</li>
                                <li><strong>보유 및 이용기간:</strong> 메시지 발송 완료 후 즉시 파기</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="policy-section">
                    <h2>제5조 (개인정보처리의 위탁)</h2>
                    <p>회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
                    
                    <div className="subsection">
                        <table className="delegation-table">
                            <thead>
                                <tr>
                                    <th>위탁받는 자</th>
                                    <th>위탁하는 업무의 내용</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Amazon Web Services (AWS)</td>
                                    <td>서버 호스팅 및 데이터 저장</td>
                                </tr>
                                <tr>
                                    <td>NICE평가정보(주)</td>
                                    <td>본인 확인 및 실명 인증 서비스</td>
                                </tr>
                                <tr>
                                    <td>(주)비즈뿌리오</td>
                                    <td>알림톡 및 인증번호 발송</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p className="subsection-note">
                        회사는 위탁계약 체결 시 개인정보 보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 
                        기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 
                        계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>제6조 (정보주체의 권리·의무 및 행사방법)</h2>
                    <p>정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                    
                    <div className="subsection">
                        <ul>
                            <li>개인정보 열람 요구</li>
                            <li>오류 등이 있을 경우 정정 요구</li>
                            <li>삭제 요구</li>
                            <li>처리정지 요구</li>
                        </ul>
                    </div>

                    <p className="subsection-note">
                        위 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 
                        회사는 이에 대해 지체없이 조치하겠습니다.
                    </p>

                    <p className="subsection-note">
                        정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 
                        완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
                    </p>

                    <p className="subsection-note">
                        위 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 
                        이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>제7조 (개인정보의 파기)</h2>
                    
                    <div className="subsection">
                        <h3>1. 파기절차</h3>
                        <p>
                            회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 
                            지체없이 해당 개인정보를 파기합니다.
                        </p>
                    </div>

                    <div className="subsection">
                        <h3>2. 파기방법</h3>
                        <ul>
                            <li><strong>전자적 파일:</strong> 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제</li>
                            <li><strong>종이 문서:</strong> 분쇄기로 분쇄하거나 소각</li>
                        </ul>
                    </div>
                </section>

                <section className="policy-section">
                    <h2>제8조 (개인정보의 안전성 확보조치)</h2>
                    <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                    
                    <div className="subsection">
                        <ul>
                            <li><strong>관리적 조치:</strong> 내부관리계획 수립·시행, 정기적 직원 교육</li>
                            <li><strong>기술적 조치:</strong> 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 
                            개인정보의 암호화, 보안프로그램 설치</li>
                            <li><strong>물리적 조치:</strong> 전산실, 자료보관실 등의 접근통제</li>
                        </ul>
                    </div>
                </section>

                <section className="policy-section">
                    <h2>제9조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h2>
                    
                    <div className="subsection">
                        <h3>1. 위치정보 수집</h3>
                        <p>
                            회사는 묘지 위치 안내 및 길찾기 서비스를 제공하기 위해 사용자의 위치정보(GPS 좌표)를 수집합니다. 
                            위치정보 수집은 사용자의 동의 하에 이루어지며, 언제든지 앱 설정에서 위치정보 제공을 거부할 수 있습니다.
                        </p>
                    </div>

                    <div className="subsection">
                        <h3>2. 방문 기록</h3>
                        <p>
                            사용자가 묘지를 방문할 때 방문 시간, 위치정보가 자동으로 기록될 수 있습니다. 
                            이는 서비스 품질 향상 및 사용자 편의를 위한 것이며, 사용자는 언제든지 방문 기록을 삭제할 수 있습니다.
                        </p>
                    </div>
                </section>

                <section className="policy-section">
                    <h2>제10조 (개인정보 보호책임자)</h2>
                    <p>
                        회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 
                        불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                    </p>
                    
                    <div className="subsection contact-info">
                        <h3>개인정보 보호책임자</h3>
                        <ul>
                            <li><strong>성명:</strong> 개인정보보호책임자</li>
                            <li><strong>연락처:</strong> 이메일 및 전화번호는 회사 고객센터를 통해 문의 가능</li>
                        </ul>
                    </div>

                    <p className="subsection-note">
                        정보주체는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 
                        피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다. 
                        회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>제11조 (권익침해 구제방법)</h2>
                    <p>
                        정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 
                        한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.
                    </p>
                    
                    <div className="subsection">
                        <ul className="contact-list">
                            <li>
                                <strong>개인정보분쟁조정위원회:</strong> (국번없이) 1833-6972 
                                (<a href="https://www.kopico.go.kr" target="_blank" rel="noopener noreferrer">www.kopico.go.kr</a>)
                            </li>
                            <li>
                                <strong>개인정보침해신고센터:</strong> (국번없이) 118 
                                (<a href="https://privacy.kisa.or.kr" target="_blank" rel="noopener noreferrer">privacy.kisa.or.kr</a>)
                            </li>
                            <li>
                                <strong>대검찰청:</strong> (국번없이) 1301 
                                (<a href="https://www.spo.go.kr" target="_blank" rel="noopener noreferrer">www.spo.go.kr</a>)
                            </li>
                            <li>
                                <strong>경찰청:</strong> (국번없이) 182 
                                (<a href="https://ecrm.cyber.go.kr" target="_blank" rel="noopener noreferrer">ecrm.cyber.go.kr</a>)
                            </li>
                        </ul>
                    </div>
                </section>

                <section className="policy-section">
                    <h2>제12조 (개인정보 처리방침의 변경)</h2>
                    <p>
                        이 개인정보 처리방침은 2026년 2월 12일부터 적용됩니다.
                    </p>
                    <p className="subsection-note">
                        이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.
                    </p>
                    <ul>
                        <li>2026년 2월 12일 ~ 현재: 현행 개인정보 처리방침</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <h2>관련 정책</h2>
                    <div className="policy-links-section">
                        <a href="/account-deletion" className="policy-link-button">
                            🗑️ 계정 및 데이터 삭제 안내
                        </a>
                    </div>
                </section>

                <footer className="policy-footer">
                    <p>본 개인정보처리방침은 2026년 2월 12일부터 시행됩니다.</p>
                </footer>
            </div>
        </div>
    );
};

export default PrivacyPolicy;

